@mixin focus-outline-state-mixin($color: var(--blue-layout-500-focus), $borderRadius: 20px) {
  &:after {
    content: "";
    position: absolute;
    left: -4px;
    top: -4px;
    width: calc(100% + 4px);
    height: calc(100% + 4px);
    background-color: transparent;
    border-radius: $borderRadius;
    border: 2px solid $color;
  }
}
